import axios from '../utils/axios';

export default function fetchResumeBuilderCandidate(params) {
    return (
        axios.get('/resumeBuilder/subscription/admin/resumeBuilderUsers', {
            params
        })
        .then(res => {
            return res.data.data
        })
        .catch(err => {
            return err;
        })
    )
}
